export default __webpack_public_path__ + "static/media/donkey.812417cc.jpg";